import React from 'react';
import './MenuSectionCard.css';
import MenuPrice from '../MenuPrice/MenuPrice';

/**
 * Props:
 * - Image: string
 * - Name: string
 * - Description: string
 * - prices: array
 * - isNewlyArrived: boolean (default false) -> shows New Arrival banner when true
 */
export default function MenuSectionCard(props) {
  const showBadge = Boolean(props.isNewlyArrived);

  return (
    <div className="MenuSectionCard">
      <div className="MenuSectionCardImageWrapper">
        <img
          src={props.Image}
          alt={props.Name}
          className="MenuSectionCardImage"
        />
      </div>

      <div className="MenuSectionCardContentWrapper">
        <span className="MenuSectionCardItemName">{props.Name}</span>
        <span className="MenuSectionCardItemDescription">
          {props.Description}
        </span>
        <div className="MenuSectionCardPrices">
          {props.prices.map((price, index) => {
            return <MenuPrice price={price} key={index} />;
          })}
        </div>
        {/* New Arrival badge in the top-left corner of the image */}
        {showBadge && (
          <div className="NewArrivalBadge" aria-label="New arrival">
            <span className="NewArrivalBadgeText">New Arrival</span>
          </div>
        )}
      </div>
    </div>
  );
}
